import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import gql from "graphql-tag";

@Injectable()
export class DocsService {
  constructor(private apollo: Apollo) {}

  list(obj?) {
  // Calculate pagination values if provided
  const variables: { first?: number; after?: string } = {};

  if (obj) {
    const { pageSize, pageIndex } = obj.paginationData;
    variables.first = pageSize;
    const offset = pageSize * pageIndex;
    variables.after = btoa(`cursor-${offset}`); // Encode offset as a base64 cursor
  }

  return this.apollo.watchQuery({
    query: gql`
      query ($first: Int, $after: String) {
        documents(first: $first, after: $after) {
          edges {
            node {
              id
              title
            }
          }
          totalCount
        }
      }
    `,
    variables,
  }).valueChanges;
}


  read(id: string) {
    return this.apollo.watchQuery({
      query: gql`
              {
                  document(id: "${id}") {
                      id
                      title
                      body
                  }
              }
          `,
    }).valueChanges;
  }

  create(obj) {
    return this.apollo.mutate({
      mutation: gql`
        mutation createDocument($title: String!, $body: String) {
          createDocument(document: { title: $title, body: $body }) {
            success
          }
        }
      `,
      variables: {
        title: obj.title,
        body: obj.body,
      },
    });
  }

  update(obj) {
    return this.apollo.mutate({
      mutation: gql`
        mutation updateDocument($id: ID!, $title: String!, $body: String) {
          updateDocument(document: { id: $id, title: $title, body: $body }) {
            success
          }
        }
      `,
      variables: {
        id: obj.id,
        title: obj.title,
        body: obj.body,
      },
    });
  }

  delete(obj) {
    return this.apollo.mutate({
      mutation: gql`
        mutation deleteDocument($id: ID!) {
          deleteDocument(document: { id: $id }) {
            success
          }
        }
      `,
      variables: {
        id: obj.id,
      },
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/docs.service.ts